import { Store } from '@tanstack/react-store'

type SnackbarSeverity = 'success' | 'error' | 'warning' | 'info'

type SnackbarItem = {
  id: string
  message: string
  severity: SnackbarSeverity
}

type SnackbarState = {
  snackbars: SnackbarItem[]
}

export const snackbarStore = new Store<SnackbarState>({
  snackbars: [],
})

// helpers
export const enqueueSnackbar = (
  message: string,
  severity: SnackbarSeverity = 'info'
) => {
  snackbarStore.setState((state) => ({
    snackbars: [
      ...state.snackbars,
      {
        id: crypto.randomUUID(),
        message,
        severity,
      },
    ],
  }))
}

export const removeSnackbar = (id: string) => {
  snackbarStore.setState((state) => ({
    snackbars: state.snackbars.filter((snackbar) => snackbar.id !== id),
  }))
}
